import React, { useState } from 'react';
import { confirmSignUp, resendSignUpCode } from 'aws-amplify/auth';
import { I18n } from 'aws-amplify/utils';
import {
  FormSection,
  FormField,
  SectionHeader,
  SectionBody,
  SectionFooter,
  Button,
  Link,
  Hint,
  Input,
  InputLabel,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent,
} from './auth-ui';

// This step used to come free: the old Authenticator rendered its own
// ConfirmSignUp for any state the app did not override, and only Greetings,
// SignIn, SignUp and ForgotPassword were overridden. Dropping the package means
// the email-verification screen has to exist here, otherwise sign-up dead-ends.
function ConfirmSignUp({ theme, authData = {}, changeState, onError }) {
  const [username, setUsername] = useState(authData.username || '');
  const [code, setCode] = useState('');
  const [pending, setPending] = useState(false);

  const confirm = async () => {
    setPending(true);
    try {
      await confirmSignUp({ username, confirmationCode: code });
      changeState('signIn', { username });
    } catch (err) {
      onError(err);
      setPending(false);
    }
  };

  const resend = async () => {
    try {
      await resendSignUpCode({ username });
    } catch (err) {
      onError(err);
    }
  };

  return (
    <FormSection theme={theme} data-test="confirm-sign-up-section">
      <SectionHeader theme={theme} data-test="confirm-sign-up-header-section">
        {I18n.get('Confirm Sign Up')}
      </SectionHeader>
      <SectionBody theme={theme} data-test="confirm-sign-up-body-section">
        <FormField theme={theme}>
          <InputLabel theme={theme}>{I18n.get('Username')} *</InputLabel>
          <Input
            placeholder={I18n.get('Username')}
            theme={theme}
            name="username"
            onChange={(e) => setUsername(e.target.value)}
            disabled={Boolean(authData.username)}
            value={username}
            data-test="confirm-sign-up-username-input"
          />
        </FormField>
        <FormField theme={theme}>
          <InputLabel theme={theme}>
            {I18n.get('Confirmation Code')} *
          </InputLabel>
          <Input
            autoFocus={true}
            placeholder={I18n.get('Enter your code')}
            theme={theme}
            name="code"
            autoComplete="off"
            onChange={(e) => setCode(e.target.value)}
            value={code}
            data-test="confirm-sign-up-confirmation-code-input"
          />
          <Hint theme={theme}>
            {I18n.get('Lost your code? ')}
            <Link
              theme={theme}
              onClick={resend}
              data-test="confirm-sign-up-resend-code-link"
            >
              {I18n.get('Resend Code')}
            </Link>
          </Hint>
        </FormField>
      </SectionBody>
      <SectionFooter theme={theme}>
        <SectionFooterPrimaryContent theme={theme}>
          <Button
            theme={theme}
            onClick={confirm}
            disabled={pending}
            data-test="confirm-sign-up-confirm-button"
          >
            {I18n.get('Confirm')}
          </Button>
        </SectionFooterPrimaryContent>
        <SectionFooterSecondaryContent theme={theme}>
          <Link
            theme={theme}
            onClick={() => changeState('signIn')}
            data-test="confirm-sign-up-back-to-sign-in-link"
          >
            {I18n.get('Back to Sign In')}
          </Link>
        </SectionFooterSecondaryContent>
      </SectionFooter>
    </FormSection>
  );
}

export default ConfirmSignUp;
